define(["require", "exports", "../model/services/EventManager", "./Events", "react-ga"], function (require, exports, EventManager_1, Events_1, ReactGA) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AnalyticsStore = void 0;
    const GaTrackingEnabled = false;
    class AnalyticsStore {
        constructor(storeManager) {
            Object.defineProperty(this, "storeManager", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "enabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            this.storeManager = storeManager;
            if (GaTrackingEnabled) {
                EventManager_1.EventManager.Instance.on(Events_1.CONFIG_READY_EVENT, (config) => {
                    var _a;
                    if (config.GaTrackingEnabled && config.GaTrackingId) {
                        const userId = storeManager.userStore.IsLoggedIn ? (_a = storeManager.userStore.User) === null || _a === void 0 ? void 0 : _a.id : null;
                        console.log(`GA: Init tracking: ${config.GaTrackingId}. UserId: ${userId}`);
                        ReactGA.initialize(config.GaTrackingId, {
                            debug: false,
                            titleCase: false,
                            gaOptions: {
                                userId
                            }
                        });
                        this.enabled = true;
                    }
                });
            }
            EventManager_1.EventManager.Instance.on(Events_1.USER_LOGGED_IN_EVENT, (user) => {
                if (this.enabled) {
                    console.log(`GA: Set user to ${user.id}`);
                    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.set({ userId: user.id });
                }
            });
            EventManager_1.EventManager.Instance.on(Events_1.ROUTE_ENTER_EVENT, (path) => {
                if (this.enabled) {
                    ReactGA.pageview(path);
                }
            });
        }
    }
    exports.AnalyticsStore = AnalyticsStore;
});
